<template>
  <div class="page-content">
    <div class="kinput-item-wrpper" v-loading="codeLoding">
      <div class="kinput-item">
        <input
          type="text"
          name="title"
          v-model.trim="model.title"
          class="kinput-item__input"
          placeholder="请输入咨询标题"
        />
      </div>
      <div class="kinput-item textarea">
        <textarea
          type="text"
          name="content"
          v-model.trim="model.content"
          class="kinput-item__input"
          placeholder="请输入咨询内容"
        />
      </div>
      <div class="kinput-item">
        <input
          type="text"
          name="username"
          v-model.trim="model.username"
          class="kinput-item__input"
          placeholder="请输入您的姓名"
        />
      </div>
      <div class="kinput-item">
        <input
          type="tel"
          name="phone"
          v-model.trim="model.phone"
          class="kinput-item__input"
          placeholder="请输入您的联系方式"
        />
      </div>
      <div class="kinput-item kinput-item__code">
        <input
          type="text"
          name="code"
          v-model.trim="model.code"
          class="kinput-item__input"
          placeholder="请输入验证码"
        />
        <!-- <div class="code" @click="sendCode">{{ codeText }}</div> -->
        <div class="code">
          <Code @getData="getCodeData"></Code>
        </div>
      </div>
      <div class="kinput-item btn-wrap">
        <button class="btn" @click="onSubmit">点击提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { postWangshangzixun } from "../../apis/hudong";
import Code from "./components/Code.vue";

export default {
  components: {
    Code,
  },
  data() {
    return {
      codeLoding: false,
      code: "",
      codeText: "获取验证码",
      model: {
        title: "",
        content: "",
        username: "",
        phone: "",
        code: "",
      },
    };
  },
  methods: {
    getCodeData(code) {
      this.code = code;
    },
    sendCode() {
      this.codeLoding = true;
      setTimeout(() => {
        this.codeText = "已发送";
        this.codeLoding = false;
      }, 300);
    },
    onSubmit() {
      const { title, username, phone, code } = this.model;
      if (!title) {
        this.$message.warning("请输入咨询标题");
        return;
      }
      if (!username) {
        this.$message.warning("请输入您的姓名");
        return;
      }
      if (!phone) {
        this.$message.warning("请输入您的联系方式");
        return;
      }
      if (phone.length !== 11 || !String(phone).startsWith("1")) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!code) {
        this.$message.warning("请输入验证码");
        return;
      }
      if (code.toLocaleLowerCase() !== this.code.toLocaleLowerCase()) {
        this.$message.warning("请输入正确的验证码");
        return;
      }
      this.postWangshangzixun();
    },
    async postWangshangzixun() {
      const body = {
        ...this.model,
      };
      const { msg } = await postWangshangzixun(body);
      this.$message.success(msg);
      this.$data.model = this.$options.data(this).model;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
}
.kinput-item-wrpper {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.kinput-item {
  width: 600px;
  height: 42px;
  background: rgba(245, 245, 245, 0.39);
  border-radius: 5px;
  margin-bottom: 12px;
  padding: 0 22px;
  &.textarea {
    height: 168px;
    padding-top: 12px;
    line-height: 20px;
  }
  &.kinput-item__code {
    padding-right: 0;
    display: flex;
    .code {
      width: 200px;
      height: 42px;
      cursor: pointer;
      background: #0d7ce4;
      border-radius: 5px;
      color: #fff;
      border: none;
      font-weight: 500;
      text-align: center;
      line-height: 42px;
      font-size: 16px;
      font-size: var(--font-size-16);
      font-weight: 500;
      margin-left: 12px;
    }
  }
  .kinput-item__input {
    appearance: none;
    width: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    font-size: var(--font-size-14);
    color: #303133;
    background-color: rgba(245, 245, 245, 0.39);
    height: 100%;
    // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    //   Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    line-height: 20px;
    &::placeholder {
      font-size: 14px;
      font-size: var(--font-size-14);
      font-weight: 500;
      line-height: 20px;
      color: #c0c4cc;
    }
  }
  &.btn-wrap {
    padding: 0;
  }
  .btn {
    width: 100%;
    width: 600px;
    height: 52px;
    cursor: pointer;
    background: #0d7ce4;
    border-radius: 5px;
    color: #fff;
    border: none;
    font-size: 18px;
    font-size: var(--font-size-18);
    font-weight: 500;
    // line-height: 25px;
  }
}
</style>
